module.exports = __webpack_public_path__ + "static/img/3业务布局-智能机器人.098d5fc1.png";